import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { CountriesService } from 'src/app/countries/countries.service';
import { ProvincesService } from '../provinces.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-provinces-detail',
  templateUrl: './provinces-detail.component.html',
  styleUrls: ['./provinces-detail.component.scss']
})
export class ProvincesDetailComponent implements OnInit {
  @ViewChild("formDetails") public formDetails: NgForm;
  public province: any = {
    name: ""
  };
  public countries: any[] = [];

  constructor(
    private provincesService: ProvincesService,
    private countriesService: CountriesService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private coreFormService: CoreFormService,
    private coreDialogService: CoreDialogService,
    private _location: Location
  ) { }

  ngOnInit(): void {
    this.loadCountries();
    this.route.params.subscribe(params => {
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    if (id != 0) {
      this.provincesService.get(id).subscribe(
        data => {
          this.province = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  loadCountries() {
    this.countriesService.all({}).subscribe(
      data => {
        this.countries = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }
  cancel() {
    this.router.navigate(['/configuration/provinces']);
  }

  save() {
    if (this.coreFormService.validate(this.formDetails)) {
      this.provincesService.save(this.province.id, this.province).subscribe(
        data => {
          var _msg = (this.province.id != 0 && typeof this.province.id !== "undefined") ? "modificada" : "añadida";
          this.messageService.add({ closable: false, severity: 'success', summary: "Provincia " + _msg + " correctamente" });
          this.router.navigate(['/configuration/provinces']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  delete() {
    this.coreDialogService.confirm({
      message: '¿Está seguro de que desea eliminar esta provincia?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.countriesService.delete(this.province.id).subscribe(
          res => {
            this.messageService.add({ closable: false, severity: 'success', summary: 'Provincia eliminada correctamente' });
            this._location.back();
            //this.router.navigate(['/configuration/provinces']);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

  isDuplied() {
    var errorMessage = "";
    if (this.province.name.length <= 0) {
      //errorMessage += "El nombre no puede estar vacío. \n";
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El nombre no puede estar vacío." });
    }
    /*if(errorMessage){
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: errorMessage });
    }*/
    this.provincesService.isDuplied(this.province).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una provincia con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save();
        }
      }
    );
  }
}
